import * as statusConstants from '../../constants/form/statusConstants';
import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    STATUS_HISTORY: {
        id: 'form.header.statusHistory',
        defaultMessage: 'History of Changes'
    },
    [statusConstants.HDI_TICKET_STATUS_NEW]: {
        id: 'form.status.new',
        defaultMessage: 'New'
    },
    [statusConstants.HDI_TICKET_STATUS_OPENED]: {
        id: 'form.status.opened',
        defaultMessage: 'Opened'
    },
    [statusConstants.HDI_TICKET_STATUS_REOPENED]: {
        id: 'form.status.reopened',
        defaultMessage: 'Reopened'
    },
    [statusConstants.HDI_TICKET_STATUS_CLOSED]: {
        id: 'form.status.closed',
        defaultMessage: 'Closed'
    },
    [statusConstants.HDI_TICKET_STATUS_ON_HOLD]: {
        id: 'form.status.onHold',
        defaultMessage: 'On hold'
    },
    [statusConstants.HDI_TICKET_STATUS_SUSPENDED]: {
        id: 'form.status.suspended',
        defaultMessage: 'Suspended'
    },
    [statusConstants.HDI_TICKET_STATUS_NEWOPENED]: {
        id: 'form.status.newOrOpened',
        defaultMessage: 'New or Opened'
    },
    [statusConstants.HDI_TICKET_STATUS_WAITING_ON_OWNER]: {
        id: 'form.status.waitingOnOwner',
        defaultMessage: 'Waiting on owner'
    }
});

export default messages;
